import { b2x } from '@b2x/react/src';
import React from 'react';

import { t } from './i18n/i18n';

// eslint-disable-next-line @typescript-eslint/ban-types
type AdditionalPropertiesFormValues = {};

// eslint-disable-next-line @typescript-eslint/ban-types
type AdditionalPropertiesValidationSchema = b2x.yup.ObjectSchema<{}>;

export type NewsletterFormProps = Omit<
  b2x.NewsletterFormProps<AdditionalPropertiesFormValues, AdditionalPropertiesValidationSchema>,
  | 'additionalPropertiesInitialValues'
  | 'additionalProperties'
  | 'additionalPropertiesValidationSchema'
  | 'validationSchemaSelector'
>;

export const NewsletterForm = ({
  ctaContainerClassName,
  emailFieldStyle = 'textInput',
  onSuccess,
  redirectToHomeOnSuccessModalClose,
  ...otherProps
}: NewsletterFormProps) => {
  const { showModal } = b2x.useModals();
  const navigate = b2x.router.useNavigate();

  const onSuccessCallback = React.useCallback(() => {
    onSuccess && onSuccess();
    b2x.storage.setBoolean('newsletterConsent', true, true);
    showModal({
      buttons: [
        {
          close: true,
          label: t('form.newsletterForm.outcome.success.buttons.ok.label'),
        },
      ],
      children: t('form.newsletterForm.outcome.success.body'),
      className: 'modal-newsletter-form',
      onClose: () => {
        if (redirectToHomeOnSuccessModalClose) {
          navigate('/');
        }
      },
      title: t('form.newsletterForm.outcome.success.title'),
    });
  }, [navigate, onSuccess, redirectToHomeOnSuccessModalClose, showModal]);

  return (
    <b2x.NewsletterFormHelper<AdditionalPropertiesFormValues, AdditionalPropertiesValidationSchema>
      {...otherProps}
      emailFieldStyle={emailFieldStyle}
      onSuccess={onSuccessCallback}
      redirectToHomeOnSuccessModalClose
      validationSchemaSelector={{ name: false, surname: false }}
    >
      {({ fieldsHelper, formik }) => (
        <>
          {emailFieldStyle === 'inputGroup' && (
            <b2x.FormGroup {...fieldsHelper.email.formGroup} label={undefined}>
              <b2x.InputGroup {...fieldsHelper.email.inputGroup}>
                <b2x.TextInput className="me-3" {...fieldsHelper.email.textInput} />
              </b2x.InputGroup>
            </b2x.FormGroup>
          )}
          {emailFieldStyle === 'textInput' && (
            <b2x.FormGroup {...fieldsHelper.email.formGroup} label={undefined}>
              <b2x.TextInput {...fieldsHelper.email.textInput} />
            </b2x.FormGroup>
          )}
          <fieldset>
            <legend className="visually-hidden">{fieldsHelper.consents.legend}</legend>
            <b2x.FormGroup {...fieldsHelper.consents.newsletterConsent.formGroup} label={undefined}>
              <b2x.Checkbox
                {...fieldsHelper.consents.newsletterConsent.checkbox}
                labelClassName="extra-small text-start"
              />
            </b2x.FormGroup>
          </fieldset>
          <div className="d-lg-block d-grid text-center mt-3">
            <b2x.Button
              {...fieldsHelper.buttons.submit}
              label={t('form.newsletterForm.buttons.submit.label')}
              variant="primary"
            />
          </div>
        </>
      )}
    </b2x.NewsletterFormHelper>
  );
};
